import { useState } from "react";
import { heroCategoryChips, featuredWorks } from "@/mocks/narutoData";

export default function Hero() {
  const [keyword, setKeyword] = useState("");

  const submitSearch = () => {
    const kw = keyword.trim();
    const el = document.getElementById("featured");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    if (kw) {
      // 简单反馈：定位到热门推荐区，并高亮首条
      const first = document.querySelector('[data-work]');
      if (first) (first as HTMLElement).scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section id="top" className="relative flex min-h-[100vh] w-full items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20epic%20anime%20night%20sky%20over%20a%20hidden%20ninja%20village%20with%20large%20carved%20faces%20on%20a%20mountain%2C%20orange%20and%20crimson%20flame%20lights%2C%20drifting%20fire%20spirals%20and%20shuriken%20silhouettes%2C%20moonlit%20mist%2C%20moody%20dramatic%20cinematic%2C%20deep%20black%20and%20warm%20orange%20palette%2C%20high%20detail%20anime%20background%20art&width=1600&height=1000&seq=hero-bg&orientation=landscape"
          alt="夜色笼罩的木叶忍者村，橙红火光与写轮眼剪影"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-background-50" />
      </div>

      <div className="relative z-10 mx-auto w-full max-w-[1200px] px-4 py-32 md:py-40">
        <div className="mx-auto w-full max-w-3xl text-center">
          <div className="inline-flex items-center gap-2 rounded-full border border-primary-400/40 bg-primary-500/10 px-4 py-1.5 text-xs text-primary-400 md:text-sm">
            <i className="ri-fire-fill" />
            火影忍者同人作品聚合站 · 持续更新中
          </div>

          <h1 className="mt-6 font-heading text-3xl md:text-5xl lg:text-6xl font-black leading-tight text-background-50">
            火影忍者同人
            <span className="block mt-2 text-transparent bg-clip-text bg-gradient-to-r from-primary-400 via-secondary-400 to-accent-400">
              作品合集与热门导航
            </span>
          </h1>

          <p className="mx-auto mt-6 max-w-2xl text-sm md:text-base leading-relaxed text-background-200">
            从经典长篇到冷门短篇，按角色、CP、题材分类整理，收录全站热门同人合集与优质推荐。
            快速找到你想看的火影忍者同人作品，一次逛遍木叶与晓的万千故事。
          </p>

          <div className="mx-auto mt-8 flex w-full max-w-xl flex-col sm:flex-row gap-2 rounded-lg bg-background-50/10 p-1.5 backdrop-blur-sm border border-background-200/40">
            <div className="flex flex-1 items-center gap-2 px-3">
              <i className="ri-search-line text-background-200" />
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && submitSearch()}
                placeholder="搜索作品、角色或CP关键词…"
                className="w-full bg-transparent py-3 text-sm text-background-50 placeholder:text-background-300 outline-none"
              />
            </div>
            <button
              onClick={submitSearch}
              className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              开始搜索
            </button>
          </div>

          <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
            {heroCategoryChips.map((chip) => (
              <button
                key={chip}
                onClick={() => {
                  setKeyword(chip);
                  scrollTo("featured");
                }}
                className="whitespace-nowrap rounded-full border border-background-200/40 bg-background-50/20 px-3.5 py-1.5 text-xs text-background-100 transition-colors hover:border-primary-400 hover:text-primary-400"
              >
                {chip}
              </button>
            ))}
          </div>

          <div className="mx-auto mt-10 grid w-full max-w-md grid-cols-3 gap-4">
            <div className="rounded-lg border border-background-200/30 bg-background-50/20 p-3 backdrop-blur-sm">
              <div className="font-heading text-xl md:text-2xl font-bold text-primary-400">680+</div>
              <div className="mt-1 text-xs text-background-200">收录作品</div>
            </div>
            <div className="rounded-lg border border-background-200/30 bg-background-50/20 p-3 backdrop-blur-sm">
              <div className="font-heading text-xl md:text-2xl font-bold text-secondary-400">24</div>
              <div className="mt-1 text-xs text-background-200">角色专题</div>
            </div>
            <div className="rounded-lg border border-background-200/30 bg-background-50/20 p-3 backdrop-blur-sm">
              <div className="font-heading text-xl md:text-2xl font-bold text-accent-400">36</div>
              <div className="mt-1 text-xs text-background-200">CP分类</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 z-10 -translate-x-1/2 animate-bounce text-background-200">
        <i className="ri-arrow-down-line text-2xl" />
      </div>
    </section>
  );
}